import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrolltoContent = (top = 100) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  }, [location.key, top]);

  const scrollToTop = (customTop = top) => {
    window.scrollTo({
      top: customTop,
      behavior: 'smooth',
    });
  };

  return { scrollToTop };
};
